import { useQuery } from "@tanstack/react-query";

import cookiesHelper from "../../helpers/cookies";

import api from "../apiClient";

const useGetSchoolUsers = (schoolId: number | null) => {
    const queryFn = async () => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`users/school/${schoolId ?? 0}`);
        return res.data?.length ? res.data : [];
    };

    return useQuery({
        queryKey: ['users', schoolId],
        queryFn,
        retry: 0,
        enabled: !!schoolId,
    });
};

export default useGetSchoolUsers;